import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../../helpers/helper';
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { CuadreService } from '../../../services/cuadre.service';
import { DecimalPipe } from '@angular/common';
@Component({
  selector: 'app-editar-apertura',
  templateUrl: './editar-apertura.component.html',
  styleUrls: ['./editar-apertura.component.css']
})
export class EditarAperturaComponent implements OnInit {
  @Input() ID_APERTURA;
  @Input() modals: any;
  @ViewChild('alert') alert: ElementRef;
  fechaApertura: NgbDateStruct;
  now = new Date(this.helper.getDate());
  rutas = [];
  empleados = [];
  form: FormGroup;
  loading = false;
  change = false;
  empleado: any;
  constructor(public activeModal: NgbActiveModal, private helper: Helper,
    private rutaService: RutasService,
    private cuadreService: CuadreService,
    private empleadoService: EmpleadosServicio,
    private Render: Renderer2) {
      this.initForm();
      this.initRutas();
      this.empleado = this.empleadoService.datosEmpleado;
    }

  ngOnInit() {
    this.initApertura();
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas().subscribe(res => this.rutas = res.rutas);
  }

  private initEmpleados(): void {
    this.form.get('ruta').valueChanges.subscribe(res => {
      this.form.get('empleado').setValue('');
      if (res) {
        this.empleadoService.empleadosPorRutasAsignadas(res)
        .subscribe(result => {
          this.empleados = result;
          this.form.get('empleado').enable();
        });
      } else {
        this.form.get('empleado').setValue('');
        this.form.get('empleado').disable();
        this.empleados = [];
      }
    });
  }

  private initForm(): void {
    this.form = new FormGroup({
      ID_APERTURA_DIA: new FormControl('', Validators.required),
      fecha_apertura: new FormControl('', Validators.required),
      ruta: new FormControl('', Validators.required),
      empleado: new FormControl('', Validators.required),
      capital: new FormControl(''),
      recargas: new FormArray([]),
      gastos: new FormArray([]),
      acompanante: new FormControl(''),
      nota_adicional: new FormControl(''),
    });

    this.form.get('fecha_apertura').disable();
    this.form.get('ruta').disable();
    this.form.get('empleado').disable();
  }

  private initApertura() {
    this.cuadreService.obtenerApertura(this.ID_APERTURA)
    .subscribe((res: any) => {
      this.empleadoService.empleadosPorRutasAsignadas(res.ID_RUTA)
      .subscribe(result => {
        this.empleados = result;
      });
      this.form.get('ID_APERTURA_DIA').setValue(this.ID_APERTURA);
      this.form.get('fecha_apertura').setValue({
        year:  parseFloat(res.fecha_apertura.split('-')[0]),
        month:  parseFloat(res.fecha_apertura.split('-')[1]),
        day: parseFloat(res.fecha_apertura.split('-')[2].split('T')[0])
      });
      this.form.get('ruta').setValue(res.ID_RUTA);
      this.form.get('empleado').setValue(res.entregadoA);
      this.form.get('capital').setValue(res.capital);
      this.form.get('acompanante').setValue(res.acompanante);
      this.form.get('nota_adicional').setValue(res.nota_adicional);

 
      if (res.recargas) {
        (<FormArray>this.form.get('recargas')).controls = [];
        for (const row of res.recargas) {

          (<FormArray>this.form.get('recargas')).push(
            new FormGroup({
              ID_APERTURA_DETALLE: new FormControl(row.ID_APERTURA_DETALLE, Validators.required),
              nota: new FormControl(row.nota || 'Capital añadido', Validators.required),
              capital: new FormControl(row.capital, [Validators.required, Validators.min(1)])
            })
          );
        }
      }
      if (res.gastos) {
        (<FormArray>this.form.get('gastos')).controls = [];
        for (const row of res.gastos) {

          (<FormArray>this.form.get('gastos')).push(
            new FormGroup({
              ID_GASTO: new FormControl(row.ID_GASTO, Validators.required),
              gasto: new FormControl(row.gasto, Validators.required),
              capital: new FormControl(row.capital, [Validators.required, Validators.min(1)])
            })
          );
        }
      }

      if (res.cargoCobros) {
        this.form.get('fecha_apertura').disable();
        this.form.get('ruta').disable();
        this.form.get('empleado').disable();
      } else {
        this.form.get('fecha_apertura').enable();
        this.form.get('ruta').enable();
        this.form.get('empleado').enable();
      }

      this.initEmpleados();
    });
  }

  editarApertura() {
    if (this.form.valid && !this.loading && !this.verificarFormArrays()) {
      this.loading = true;
      this.cuadreService.editarApertura(this.form.value)
        .subscribe( () => {
          this.loading = false;
          this.alertSuccess();
        }, err => {

          this.loading = false;
          if ((err.status === 401 && err.error === 'reload') || err.status === 410) {
            this.initApertura();
          } else if (err.status == 403) {
            this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
            'red',
            'modern',
            false,
            'fa fa-file-text');
          }
        });
    } else {
      for (const key of Object.keys(this.form.controls)) {
        this.form.get(key).markAsTouched();
      }
    }
  }

  eliminar(index) {
    const { ID_APERTURA_DETALLE, nota, capital } = (<FormArray>this.form.get('recargas')).controls[index].value;
    const msg = `Eliminar el capital añadido <b>${ nota }</b> de <b>${  new DecimalPipe('en-US').transform(capital, '1.0-2') }</b>`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange', 'material').then(resp => {
      if (resp === 'SI') {
        this.loading = true;
        this.cuadreService.eliminarCapitalAnadido(ID_APERTURA_DETALLE)
          .subscribe( (res) => {
            if (res) {
              (<FormArray>this.form.get('recargas')).controls.splice(index, 1);
              this.alertSuccess();
            }
            this.loading = false;
          }, err => {

            this.loading = false;
            if (err.status === 401 && err.error === 'reload') {
              this.initApertura();
            } else if (err.status == 403) {
              this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
              'red',
              'modern',
              false,
              'fa fa-file-text');
            }
          });
      }
    });
  }

  eliminarGasto(index) {
    const { ID_GASTO, gasto, capital } = (<FormArray>this.form.get('gastos')).controls[index].value;
    const msg = `Eliminar el gasto <b>${ gasto }</b> de <b>${  new DecimalPipe('en-US').transform(capital, '1.0-2') }</b>`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange', 'material').then(resp => {
      if (resp === 'SI') {
        this.loading = true;
        this.cuadreService.eliminarGasto(ID_GASTO)
          .subscribe( (res) => {
            if (res) {
              (<FormArray>this.form.get('gastos')).controls.splice(index, 1);
              this.alertSuccess();
            }
            this.loading = false;
          }, err => {
            this.loading = false;
            if (err.status === 401 && err.error === 'reload') {
              this.initApertura();
            }
          });
      }
    });
  }

  private alertSuccess() {
    this.change = true;
    setTimeout( () => {
      this.Render.addClass(this.alert.nativeElement, 'fadeOut');
      this.form.markAsUntouched();
    }, 3000);
    setTimeout( () => this.change = false, 3800);
  }

  private verificarFormArrays(): boolean {
    let error = false;
    for (const row of (<FormArray>this.form.get('recargas')).controls) {
      if (row.invalid) { error = true; break; }
    }

    if (!error) {
      for (const row of (<FormArray>this.form.get('gastos')).controls) {
        if (row.invalid) { error = true; break; }
      }
    }
    return error;
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/editar-apertura/editar-apertura.component.ts